import { MaybeRef, computed, ref, watch } from "vue";
import useCountryCodes from "./useCountryCodes";

interface Props {
  ids: MaybeRef<(number | string)[] | undefined>;
  immediate?: boolean;
}

const useCountryNames = (props: Props) => {
  const { immediate } = props;
  const ids = ref(props.ids);

  const {
    countryCodes,
    isFetching: fetchingCountryCodes,
    isLoading: loadingCountryCodes,
    searchCountryCodes,
    resetState: resetCountryCodes,
  } = useCountryCodes({ params: { ids }, immediate });

  const countryNames = computed(() => {
    return countryCodes.value.map(({ name }) => name);
  });

  watch(ids, async () => {
    resetCountryCodes();
    await searchCountryCodes();
  });

  return {
    countryNames,
    countryCodes,
    fetchingCountryCodes,
    loadingCountryCodes,
    searchCountryCodes,
    resetCountryCodes,
  };
};

export default useCountryNames;
